<div class="modal-header" [ngStyle]="{
    'justify-content': 'right',
    height: '40px',
    backgroundColor: (Merchant$ | async)?.webapp_settings?.menu_color,
    'border-bottom':
      (Merchant$ | async)?.webapp_settings?.menu_border_width +
      'px solid ' +
      (Merchant$ | async)?.webapp_settings?.menu_border_color,
  }">
  <a (click)="decline()" id="btnnotification" class="close-icon">
    <i [ngStyle]="{
            color: (Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae,
          }" class="zmdi zmdi-close zmdi-hc-fw"></i>
  </a>
</div>
<div class="modal-body">
  <h5 [ngStyle]="{
        color: (Merchant$ | async)?.webapp_settings?.menu_font_color_allpage,
      }">
    {{ title }}
  </h5>
  <p [ngStyle]="{
        color: (Merchant$ | async)?.webapp_settings?.menu_font_color_allpage,
      }" id="textcontent">
    {{ message }}
  </p>
</div>
<div class="modal-footer" [ngStyle]="{ display: 'block' }">
  <div class="col m-0 d-grid">
    <button type="button" class="btn btn-orange-light-theme btn-lgfont-size-15" [ngStyle]="{
            color: (Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae,
            backgroundColor: (Merchant$ | async)?.webapp_settings?.menu_color,
            border:
              (Merchant$ | async)?.webapp_settings?.menu_border_width +
              'px solid ' +
              (Merchant$ | async)?.webapp_settings?.menu_border_color,
          }" (click)="accept()">
      {{ btnOkText }}
    </button>
  </div>
  <div class="col m-0 d-grid">
    <button type="button" class="btn btn-orange-light-theme btn-lg font-size-15 mt-2" [ngStyle]="{
            color: (Merchant$ | async)?.webapp_settings?.menu_font_color_homepgae,
            backgroundColor: (Merchant$ | async)?.webapp_settings?.menu_color,
            border:
              (Merchant$ | async)?.webapp_settings?.menu_border_width +
              'px solid ' +
              (Merchant$ | async)?.webapp_settings?.menu_border_color,
          }" (click)="decline()">
      {{ btnCancelText }}
    </button>
  </div>
</div>
